// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,

  // region: 'us-west-2',

  // identityPoolId: 'us-west-2:d240f8b7-b499-4f9a-91e0-0b57060b1d24',
  // userPoolId: 'us-west-2_CQm7xnQ9p',
  // clientId: '6ujmeruv4ee5q89e423p72gktd',

  // apiUrl: 'https://xpcc7mh7h8.execute-api.us-west-2.amazonaws.com/development/',

  // bucket: 'com-liquitics-tenant-lqtcs'
};
